import { Deserializable } from '../../protocols/deserializable';
import { Address } from '../dto/address';
import { MemberPersonalInformationOnboardingFormGroup } from '../../../views/shared/components/member-personal-information-onboarding-modal/member-personal-information-onboarding-form-group';

export class MemberPersonalInformationOnboardingRequest implements Deserializable {
  public preferredName: string | null = null;
  public genderId!: number;
  public pronounId: number | null = null;
  public primaryPhoneNumberCountryCode!: string;
  public primaryPhoneNumber!: string;
  public secondaryPhoneNumberCountryCode: string | null = null;
  public secondaryPhoneNumber: string | null = null;
  public address!: Address;
  onDeserialize(): void {}

  constructor(form: MemberPersonalInformationOnboardingFormGroup) {
    this.preferredName = form.controls.preferredName.value ?? null;
    this.genderId = form.controls.genderId.value ?? 0;
    this.pronounId = form.controls.pronounId.value ?? null;
    this.primaryPhoneNumberCountryCode = form.controls.primaryPhoneNumberCountryCode.value ?? '';
    this.primaryPhoneNumber = form.controls.primaryPhoneNumber.value ?? '';
    if (form.controls.secondaryPhoneNumberCountryCode.value && form.controls.secondaryPhoneNumber.value) {
      this.secondaryPhoneNumberCountryCode = form.controls.secondaryPhoneNumberCountryCode.value ?? '';
      this.secondaryPhoneNumber = form.controls.secondaryPhoneNumber.value ?? '';
    }
    const address = form.controls.address.getRawValue();
    this.address = {
      addressLine1: address.addressLine1 ?? '',
      addressLine2: address.addressLine2 ?? '',
      addressLine3: address.addressLine3 ?? '',
      city: address.city ?? '',
      stateId: address.stateId ?? 0,
      countryId: address.countryId ?? 0,
      postalCode: address.postalCode ?? ''
    } as Address;
  }
}
